/**
 * Principal Care Management (PCM) Billing Utilities
 * CPT code definitions, descriptions, and helper extractors for PCM.
 */

export const PCM_CPT_CODES = ['99424', '99425', '99426', '99427'];

export const PCM_CPT_DESCRIPTIONS = Object.freeze({
  '99424': 'PCM Physician/QHP — First 30 min per calendar month',
  '99425': 'PCM Physician/QHP — Additional 30 min per calendar month',
  '99426': 'PCM Clinical Staff — First 30 min per calendar month',
  '99427': 'PCM Clinical Staff — Additional 30 min per calendar month',
});

/**
 * Extract principal condition string for a PCM patient.
 * Checks all possible fields on patient objects or care plans.
 */
export function extractPrincipalCondition(patient) {
  if (!patient) return '';

  if (typeof patient.principal_condition === 'string' && patient.principal_condition.trim()) {
    return patient.principal_condition.trim();
  }
  if (typeof patient.primary_condition === 'string' && patient.primary_condition.trim()) {
    return patient.primary_condition.trim();
  }
  if (typeof patient.disease === 'string' && patient.disease.trim()) {
    return patient.disease.trim();
  }

  const rawConditions = patient.icd_codes ||
    patient.chronic_conditions ||
    patient.chronicDiseases ||
    patient.chronic_diseases ||
    patient.conditions ||
    patient.diagnoses;

  if (Array.isArray(rawConditions) && rawConditions.length > 0) {
    const first = rawConditions[0];
    if (typeof first === 'string' && first.trim()) return first.trim();
    if (first && typeof first === 'object') {
      return (first.condition_name || first.name || first.icd_description || first.description || first.icd_code || '').trim();
    }
  }

  if (typeof rawConditions === 'string' && rawConditions.trim()) {
    const trimmed = rawConditions.trim();
    if (!trimmed.startsWith('[') && !trimmed.startsWith('{')) {
      return trimmed.split(',')[0].trim();
    }
  }

  return '';
}
